import { useTranslation } from 'react-i18next';
import { useEmailForm } from '../hooks/useEmailForm';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function EmailForm({ person }) {
    const { t } = useTranslation();
    const {
        emailFormRegister,
        emailErrors,
        emailData,
        handleEdit,
        handleDelete,
        isEditing,
        handleSubmit,
        submitEmailForm,
        handleCancel,
        isAddDisabled,
        validationMessage
    } = useEmailForm(person);

    const onEmailSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(submitEmailForm)(e);
    };

    return (
        <div className="email-form-container">
            <h3 className="form-subtitle">
                {t('persons.email.title', {
                    name: [person.name, person.fathersName, person.surname]
                        .filter(Boolean)
                        .join(' ')
                })}
            </h3>

            <div className="form-content">
                <div className="form-section">
                    <form onSubmit={onEmailSubmit}>
                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.email.email')} <span className="required">*</span></span>
                            <div className='form-input-fields'>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder={t('persons.email.email')}
                                    className={`form-control ${emailErrors.email ? 'is-invalid' : ''}`}
                                    {...emailFormRegister('email')}
                                />
                                {emailErrors.email && (
                                    <div className="invalid-feedback">{emailErrors.email.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.email.description')} <span className="required">*</span></span>
                            <div className='form-input-fields'>
                                <input
                                    type="text"
                                    name="description"
                                    placeholder={t('persons.email.description')}
                                    className={`form-control ${emailErrors.description ? 'is-invalid' : ''}`}
                                    {...emailFormRegister('description')}
                                />
                                {emailErrors.description && (
                                    <div className="invalid-feedback">{emailErrors.description.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="email-form-controls">
                            <button 
                                type="button"
                                className={`form-btn ${isEditing ? 'btn-orange' : isAddDisabled ? 'btn-gray' : 'btn-green'}`}
                                onClick={handleSubmit(submitEmailForm)}
                                disabled={isAddDisabled && !isEditing}
                            >
                                {isEditing ? t('common.edit') : t('common.add')}
                            </button>
                            {isEditing && (
                                <button 
                                    type="button" 
                                    className="btn-gray form-btn" 
                                    onClick={handleCancel}
                                >
                                    {t('common.cancel')}
                                </button>
                            )}
                            {isAddDisabled && !isEditing && (
                                <div className="invalid-feedback d-block">
                                    {validationMessage}
                                </div>
                            )}
                        </div>
                    </form>
                </div>

                <div className="table-section">
                    <div className="email-list-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('persons.email.email')}</th>
                                    <th>{t('persons.email.description')}</th>
                                    <th>{t('common.actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailData?.email ? (
                                    <tr key={emailData.id}>
                                        <td>{emailData.email}</td>
                                        <td>{emailData.emailType}</td>
                                        <td className="action-buttons">
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                className="action-icon edit"
                                                onClick={() => handleEdit(emailData)}
                                            />
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="action-icon delete"
                                                onClick={() => handleDelete(emailData.id)}
                                            />
                                        </td>
                                    </tr>
                                ) : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
} 